import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const styles = {
	card: {
		minWidth: 500,
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)',
	},
	title: {
		marginBottom: 16,
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
};

const options = {
	scales: {
		yAxes: [
			{
				ticks: {
					beginAtZero: true,
					callback: (value) => {
						if (Number.isInteger(value)) {
							return value;
						}
						return null;
					},
					fontColor: '#afb4c1',
					fontFamily: 'Geist Sans, sans-serif',
					fontStyle: 'bold',
				},
			},
		],
		xAxes: [
			{
				ticks: {
					fontColor: '#afb4c1',
					fontFamily: 'Geist Sans, sans-serif',
					fontStyle: 'bold',
				},
			},
		],
	},
	maintainAspectRatio: false,
};

const formatReviewChart = (data) => {
	const {
		desktopSearchViews,
		mobileSearchViews,
		phoneActions,
		websiteActionsData,
		labels,
	} = data;

	const datasets = [];

	if (desktopSearchViews) {
		datasets.push({
			data: desktopSearchViews,
			label: 'Desktop Search Views',
			fill: false,
			borderWidth: 2,
			borderColor: '#c655d6',
		});
	}

	if (mobileSearchViews) {
		datasets.push({
			data: mobileSearchViews,
			label: 'Mobile Search Views',
			fill: false,
			borderWidth: 2,
			borderColor: 'rgb(155, 25, 130)',
		});
	}

	if (phoneActions) {
		datasets.push({
			data: phoneActions,
			label: 'Phone Calls',
			fill: false,
			borderWidth: 2,
			borderColor: 'rgb(55, 160, 179)',
		});
	}

	if (websiteActionsData) {
		datasets.push({
			data: websiteActionsData,
			label: 'Website Visits',
			fill: false,
			borderWidth: 2,
			borderColor: 'rgb(250, 190, 9)',
		});
	}
	return {
		labels,
		datasets,
	};
};

class MonthlyInsightsChart extends Component {
	makeDataSet = (insightData) => {
		if (insightData) {
			const labels = insightData.map((d) => d.month);

			const mobileSearchViews = insightData.map((d) =>
				d.googleInsights && d.googleInsights.mobileSearchViews
					? d.googleInsights.mobileSearchViews
					: '0'
			);
			const desktopSearchViews = insightData.map((d) =>
				d.googleInsights && d.googleInsights.desktopSearchViews
					? d.googleInsights.desktopSearchViews
					: '0'
			);

			const phoneActions = insightData.map((d) =>
				d.googleInsights && d.googleInsights.phoneActions
					? d.googleInsights.phoneActions
					: '0'
			);

			const websiteActionsData = insightData.map((d) =>
				d.googleInsights && d.googleInsights.websiteActions
					? d.googleInsights.websiteActions
					: '0'
			);

			const data = {
				mobileSearchViews,
				desktopSearchViews,
				phoneActions,
				websiteActionsData,
				labels,
			};

			const reviewChartData = formatReviewChart(data);
			return reviewChartData;
		}
		return formatReviewChart([], []);
	};

	renderBarChart = () => {
		if (this.props.insightsByMonth) {
			return (
				<Line
					data={this.makeDataSet(this.props.insightsByMonth)}
					options={options}
					height={230}
				/>
			);
		}
		return null;
	};

	render() {
		const { classes } = this.props;
		return (
			<div>
				<Card
					zdepth={1}
					style={{ marginTop: 6, maxHeight: 358, minWidth: 500 }}
				>
					<CardContent>
						<Typography
							className={classes.title}
							variant="headline"
							color="textSecondary"
						>
							Insight Data by Month (last 12 months)
						</Typography>
						{this.renderBarChart()}
					</CardContent>
				</Card>
			</div>
		);
	}
}
export default withStyles(styles)(MonthlyInsightsChart);



// WEBPACK FOOTER //
// ./src/components/review/ReviewTable/Modal/MonthlyInsightsChart.js